import React, { useEffect, useState } from "react";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { IconButton, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { Spinner } from "../ui/Spinner";
import { Download } from "@mui/icons-material";
import { UnitSystem } from "../../interfaces/interfaces";

export const PDFView = ({
  document,
  fileName,
  action,
}: {
  document: (unitSystem: UnitSystem) => React.ReactElement;
  fileName?: string;
  action?: () => void;
}) => {
  const [unitSystem, setUnitSystem] = useState<UnitSystem>('imperial');

  useEffect(() => {
    if (action) action();
  }, []);

  const doc = document(unitSystem);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "calc(100vh - 80px)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          right: 24,
          top: 24,
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 8,
        }}
      >
        <ToggleButtonGroup
          value={unitSystem}
          exclusive
          size="small"
          onChange={(_, val) => { if (val) setUnitSystem(val); }}
          sx={{ backgroundColor: '#fff', borderRadius: 1 }}
        >
          <ToggleButton value="imperial">Imperial</ToggleButton>
          <ToggleButton value="metric">Metric (SI)</ToggleButton>
        </ToggleButtonGroup>
        <PDFDownloadLink
          document={doc}
          fileName={fileName || "OSI DESIGN "}
        >
          {({ loading }) =>
            loading ? (
              <Spinner />
            ) : (
              <Tooltip title="Download">
                <IconButton
                  sx={{
                    backgroundColor: "rgb(251,171,53)",
                    "&:hover": { backgroundColor: "#FFF" },
                  }}
                  size="large"
                >
                  <Download fontSize="large" />
                </IconButton>
              </Tooltip>
            )
          }
        </PDFDownloadLink>
      </div>
      <PDFViewer
        width="100%"
        height="100%"
        style={{ border: "none" }}
      >
        {doc}
      </PDFViewer>
    </div>
  );
};
